import React from 'react';
import styled from '@emotion/styled';
import BaseDialog from '@material-ui/core/Dialog';
import theme from '../../themes/default';

export const DialogWrapper = styled('div')`
  width: ${(props) => `${props.width}px`};
  height: ${(props) => `${props.height}px`};
  border-radius: ${theme.borderRadius.medium};
  box-shadow: 0px 24px 38px rgba(0, 0, 0, 0.14),
    0px 9px 46px rgba(0, 0, 0, 0.12), 0px 11px 15px rgba(0, 0, 0, 0.2);
  margin: 0;
`;

export const StyledDialog = styled(BaseDialog)`
  margin: 0;
`;
